


















































































import Vue from "vue";
import { Component, Prop, PropSync } from 'vue-property-decorator';
import NavNode from "@/services/NavigationNode";

@Component({})
export default class Properties extends Vue {
	@Prop({ default: false }) ro !: boolean;
	@PropSync('node') localNode !: NavNode;

	get siteMapName() {
		return this.localNode && this.localNode.siteMap ? ": " + this.localNode.siteMap.name : "";
	}

	get showDeleteForNode() {
		return !this.ro && this.localNode && this.localNode.uid;
	}
}
